import React from 'react';
import { useTranslation } from 'react-i18next';
import { GlobeIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function LanguageToggle() {
  const {
    i18n
  } = useTranslation();
  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ar' : 'en';
    i18n.changeLanguage(newLang);
    document.documentElement.dir = newLang === 'ar' ? 'rtl' : 'ltr';
  };
  return <motion.button onClick={toggleLanguage} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className="fixed top-6 right-6 z-50 glass px-6 py-3 rounded-full shadow-xl hover:shadow-2xl flex items-center gap-3 transition-all" data-id="element-107">
      <GlobeIcon className="w-5 h-5 text-teal-600" data-id="element-108" />
      <span className="font-semibold text-gradient" data-id="element-109">
        {i18n.language === 'en' ? 'العربية' : 'English'}
      </span>
    </motion.button>;
}